import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setMainImageIndex } from '../../store/searchFeed';

import ProductsCarousel from '../ProductsCarousel';

const TemplateItemMainImage = () => {
  const dispatch = useDispatch();
  const currentItem = useSelector((store) => store.searchFeed.currentItem);
  const mainImageIndex = useSelector((store) => store.searchFeed.mainImageIndex);

  if (!currentItem) {
    return null;
  }

  return (
    <ProductsCarousel
      images={currentItem.images}
      mediumImages={currentItem.medium_images}
      largeImages={currentItem.large_images}
      mainImageIndex={mainImageIndex}
      onClick={(idx) => dispatch(setMainImageIndex(idx))}
      align="left"
    />
  );
};

export default TemplateItemMainImage;
